<template>
  <article class="pf-module">
    <span class="pf-module__num" aria-hidden="true">{{ module.number }}</span>
    <div class="pf-module__head">
      <i :class="module.icon" aria-hidden="true" />
      <span class="pf-module__label">{{ module.label }}</span>
    </div>
    <h3 class="pf-module__title">{{ module.title }}</h3>
    <p class="pf-module__summary">{{ module.summary }}</p>
    <p v-if="module.detail" class="pf-module__detail">{{ module.detail }}</p>
  </article>
</template>

<script>
export default {
  name: "PathfinderProgrammeCard",
  props: {
    module: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.pf-module {
  position: relative;
  padding: 22px 22px 18px;
  border-radius: 16px;
  background: var(--background-color1, #f9fafb);
  border: 1px solid var(--border-color-hover1, #e5e7eb);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.05);
  height: 100%;
  transition: transform 0.25s ease, border-color 0.25s ease;
}

.pf-module:hover {
  transform: translateY(-4px);
  border-color: var(--border-color-hover);
}

.pf-module__num {
  position: absolute;
  top: 14px;
  right: 16px;
  font-size: 0.72rem;
  font-weight: 800;
  color: var(--border-color-hover);
  opacity: 0.45;
}

.pf-module__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.pf-module__head i {
  font-size: 1.15rem;
  color: var(--border-color-hover);
}

.pf-module__label {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--border-color-hover);
}

.pf-module__title {
  margin: 0 0 8px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-color1);
}

.pf-module__summary {
  margin: 0 0 8px;
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--text-color1);
  opacity: 0.9;
}

.pf-module__detail {
  margin: 0;
  font-size: 0.88rem;
  line-height: 1.45;
  color: var(--text-color1);
  opacity: 0.7;
  font-style: italic;
}
</style>
